import { StyleSheet } from "react-native";
import { Dimensions, Platform } from "react-native";
let deviceWidth = Dimensions.get("window").width;

export default StyleSheet.create({
  modelContainer: {
    position: "absolute",
    zIndex: 99999,
    width: "100%",
    backgroundColor: "rgba(0,0,0,0.6)",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
  bodyContainer: {
    justifyContent: "center",
    alignItems: "center",
  
    height: "80%",
    backgroundColor: "#ffffff",
    paddingBottom:30,
  },

  bodyContainer_SMALL_MOBILE: {
    width: '98%'
  },
  bodyContainer_MEDIUM_MOBILE: {
    width: '96%'

  },
  bodyContainer_LARGE_MOBILE: {
    width: '90%'

  },
  bodyContainer_SMALL_TABLET: {
    width: '86%'
   
  },
  bodyContainer_MEDIUM_TABLET: {
    width: '80%'
   
  },
  bodyContainer_LARGE_TABLET: {
    width: '80%'
  
  },
  bodyContainer_LAPTOP: {
    width: '80%'
  
  },

});
